import React from 'react';
import { SectionContainer } from '../components/SectionContainer';
import SectionTitle from '../components/SectionTitle';
import { SectionBody } from '../components/SectionBody';
import { SectionLine } from '../components/SectionLine';
import { RadioContainer } from '../components/RadioContainer';
import { ReactComponent as WhatsappIcon } from 'assets/icons/whatsapp.svg';
import { ReactComponent as EmailIcon } from 'assets/icons/email.svg';
import { FormikPremiumInput } from 'modules/emergencies/components/ui/inputs/customInput';

const availableCommunicationLanguages = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'fr',
    label: 'French',
  },
  {
    value: 'it',
    label: 'Italian',
  },
  {
    value: 'pl',
    label: 'Polish',
  },
  {
    value: 'ro',
    label: 'Romanian',
  },
  {
    value: 'es',
    label: 'Spanish',
  },
  {
    value: 'pt',
    label: 'Portuguese',
  },
];

export const CustomerSection = ({ ticketFormBodyData }) => {
  const { values, showErrors, isEdit, isReadOnly } = ticketFormBodyData;
  return (
    <SectionContainer>
      <SectionTitle>Customer</SectionTitle>
      <SectionBody>
        {/* company name && id */}
        <SectionLine>
          <FormikPremiumInput
            label={'Company name'}
            name="shipper_data.company_name"
            showErrors={showErrors}
            isRequired={true}
            isDisabled={true}
          />
          <FormikPremiumInput
            label={'Company id'}
            isRequired={true}
            name="shipper_data.company_id"
            showErrors={showErrors}
            width={'160px'}
            isDisabled={true}
          />
        </SectionLine>
        {/* contact name and phone */}
        <SectionLine>
          <FormikPremiumInput
            label={'Contact full name'}
            name="shipper_data.contact_name"
            showErrors={showErrors}
            isRequired={true}
            isDisabled={isReadOnly}
          />
          <FormikPremiumInput
            type="phone"
            label="Phone number"
            name="shipper_data.phone"
            showErrors={showErrors}
            width={'160px'}
            isRequired={true}
            isDisabled={isReadOnly}
          />
        </SectionLine>
        {/* comms */}
        <SectionLine>
          {/* whattsapp or email button */}
          <RadioContainer>
            <FormikPremiumInput
              label="Whatsapp"
              type="radio"
              showErrors={false}
              name="custom.transport.selected_notification_transport"
              value="whatsapp"
              isDisabled={isReadOnly}
              checked={values.custom.transport.selected_notification_transport === 'whatsapp'}
            >
              <WhatsappIcon />
            </FormikPremiumInput>

            <FormikPremiumInput
              label="email"
              type="radio"
              showErrors={false}
              name="custom.transport.selected_notification_transport"
              value="email"
              isDisabled={isReadOnly}
              checked={values.custom.transport.selected_notification_transport === 'email'}
            >
              <EmailIcon />
            </FormikPremiumInput>
          </RadioContainer>
          {/* whatsapp input */}
          {values.custom.transport.selected_notification_transport === 'whatsapp' && (
            <FormikPremiumInput
              type="phone"
              label="Phone number"
              showErrors={showErrors}
              name="custom.transport.phone"
              customErrorFieldName="custom.transport"
              isRequired={true}
              isDisabled={isReadOnly}
              width={'290px'}
            />
          )}
          {/* mail input */}
          {values.custom.transport.selected_notification_transport === 'email' && (
            <FormikPremiumInput
              label={'E-mail'}
              showErrors={showErrors}
              name="custom.transport.email"
              customErrorFieldName="custom.transport"
              isRequired={true}
              isDisabled={isReadOnly}
            />
          )}

          {/* comns input */}
          <FormikPremiumInput
            label="Comm. language"
            showErrors={showErrors}
            name="shipper_data.language"
            type={'select'}
            isRequired={true}
            isDisabled={isEdit || isReadOnly}
            width={'160px'}
            availableOptions={availableCommunicationLanguages}
          />
        </SectionLine>
      </SectionBody>
    </SectionContainer>
  );
};
